import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { RiCheckboxCircleFill } from 'react-icons/ri'
import { Button, LibraryComponentType, Text, theme } from 'yolda-web-ui'
import { StyledInvoiceDocumentSuccess } from './InvoiceDocumentSuccess.style'

interface InvoiceDocumentSuccessProps extends LibraryComponentType {
  onAction?: () => void
}

const InvoiceDocumentSuccess: FC<InvoiceDocumentSuccessProps> = ({ onClose, onAction }) => {
  const { t } = useTranslation()

  const onClick = () => {
    onAction?.()
    onClose?.()
  }

  return (
    <StyledInvoiceDocumentSuccess>
      <div>
        <RiCheckboxCircleFill size={64} />
      </div>
      <Text as="h1" fontSize="large" fontWeight="normal" mb={theme.spacing.large} mt={theme.spacing.medium}>
        {`${t('invoices.successModal.title')}`}
      </Text>
      <Text as="p" fontSize="medium" mb={theme.spacing.large}>
        {`${t('invoices.successModal.desc1')}`}
      </Text>
      <Button onClick={onClick}>{`${t('button.complete')}`}</Button>
    </StyledInvoiceDocumentSuccess>
  )
}

InvoiceDocumentSuccess.defaultProps = {
  onAction: () => null,
}

export default InvoiceDocumentSuccess
